import { Notice, Separator } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import RoamingStore from '../../stores/RoamingStore';
import OperatorRoamingPrices from './OperatorRoamingPrices';
import { Operator } from '../RoamingInterfaces';

interface SelectedOperatorProps {
  roamingStore?: RoamingStore;
}

@observer
class SelectedOperator extends React.Component<SelectedOperatorProps> {
  private renderOperatorComment(operator: Operator) {
    if (operator.comment) {
      return (
        <>
          <Separator spacing="xsmall" color="invisible" />
          <Notice>{operator.comment}</Notice>
        </>
      );
    }
  }

  public render() {
    const {
      roamingStore: { selectedCountry, selectedOperator }
    } = this.props;

    if (!selectedOperator || !selectedCountry) {
      return null;
    }

    return (
      <>
        {this.renderOperatorComment(selectedOperator)}
        <Separator spacing="small" color="invisible" />
        <OperatorRoamingPrices headingLevel={3} />
      </>
    );
  }
}

export default inject('roamingStore')(SelectedOperator);
